"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.qs = qs;
exports.qsa = qsa;
exports.guardElement = guardElement;
/**
 * Safe query selector with null check
 */
function qs(selector) {
    return document.querySelector(selector);
}
/**
 * Safe query selector all
 */
function qsa(selector) {
    return Array.from(document.querySelectorAll(selector));
}
/**
 * Guard function - exits early if element doesn't exist
 */
function guardElement(element, errorMsg) {
    if (!element) {
        if (errorMsg)
            console.warn(errorMsg);
        return false;
    }
    return true;
}
